const state = {
  tagList: []
}

const mutations = {
  SET_TAGS(state, list) {
    state.tagList = list || []
  }
}

const actions = {
  fetchTags({ commit }) {
    return new Promise((resolve, reject) => {
      import('@/api/tag').then(({ getTagList }) => {
        getTagList()
          .then(data => {
            commit('SET_TAGS', data || [])
            resolve(data)
          })
          .catch(error => reject(error))
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
